import { AxiosError, isAxiosError } from 'axios';

interface IInvalidCredentialsResponse {
  message?: string;
  error?: string;
}

export class InvalidCredentialsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidCredentialsError';
  }

  static fromAxiosError(error: unknown): InvalidCredentialsError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IInvalidCredentialsResponse>;

    if (axiosError.response?.status === 401) {
      const message =
        axiosError.response.data?.message ||
        axiosError.response.data?.error ||
        'Invalid email or password.';
      return new InvalidCredentialsError(message);
    }

    return null;
  }
}
